<!-- <circle-progress [percent]="percent" title="" [animation]="true" [showSubtitle]="false" [subtitle]="'ddd'"
[innerStrokeWidth]="0" outerStrokeColor="#FF6B6B" innerStrokeColor="#C7E596" [animationDuration]='0'
backgroundStroke='#FFE4E4' [backgroundStrokeWidth]="18" [outerStrokeWidth]="18" [backgroundPadding]="0" [responsive]="true"
[showUnits]='false' ></circle-progress> -->

<circle-progress [percent]="percent" title="" [animation]="true" [showSubtitle]="false" [subtitle]="'ddd'"
[innerStrokeWidth]="0" [outerStrokeColor]="getPercent()" [innerStrokeColor]="'#e7e8ea'" [animationDuration]='0'
backgroundStroke='#fff0' [backgroundStrokeWidth]="18" [space]="-18" [outerStrokeWidth]="18" [innerStrokeWidth]="18" [backgroundPadding]="0" [responsive]="true"
[showUnits]='false' ></circle-progress>


<!-- <circle-progress [percent]="percent" [backgroundPadding]="0" [outerStrokeWidth]="6" title="" [showSubtitle]="false"
   [innerStrokeColor]="getPercent()" [backgroundStroke]="'#fff0'" [innerStrokeWidth]="6" [animationDuration]="1000"
  [showUnits]="false" [clockwise]="false"></circle-progress> -->
